export interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  image: string;
  link: string | null;
}

export interface ServicesContent {
  sectionTitle: string;
  sectionSubtitle: string;
  services: ServiceItem[];
}

const STORAGE_KEY = 'r3d_services_content';

export const defaultServicesContent: ServicesContent = {
  sectionTitle: 'Nos Services',
  sectionSubtitle: 'Des solutions complètes et personnalisées pour tous vos besoins en matière de lutte contre les nuisibles',
  services: [
    {
      icon: 'ri-bug-line',
      title: 'Dératisation',
      description: 'Élimination complète des rongeurs avec des méthodes efficaces et sécurisées pour protéger votre espace de vie ou de travail',
      image: 'https://public.readdy.ai/ai/img_res/6c70da369ea2d914e8b942440308a7a2.jpg',
      link: '/deratisation'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Désinsectisation',
      description: 'Traitement professionnel contre tous types d\'insectes nuisibles incluant cafards, punaises de lit, fourmis et autres parasites',
      image: 'https://readdy.ai/api/search-image?query=close%20up%20collage%20of%20common%20household%20pests%20cockroaches%20crawling%20on%20kitchen%20surface%20asian%20giant%20hornet%20wasp%20nest%20bed%20bugs%20on%20white%20mattress%20fabric%20and%20black%20ants%20trail%20on%20floor%20realistic%20macro%20photography%20pest%20infestation%20problem&width=600&height=400&seq=desinsectisation-insects-collage-2025&orientation=landscape',
      link: '/desinsectisation'
    },
    {
      icon: 'ri-plant-line',
      title: 'Désinfection',
      description: 'Services de désinfection complète pour assurer un environnement sain et hygiénique dans vos locaux professionnels ou résidentiels',
      image: 'https://readdy.ai/api/search-image?query=professional%20worker%20in%20full%20protective%20white%20hazmat%20suit%20and%20respirator%20mask%20spraying%20disinfectant%20chemical%20fog%20mist%20inside%20a%20building%20room%20sanitization%20decontamination%20service%20clean%20environment&width=600&height=400&seq=desinfection-hazmat-spray-2025&orientation=landscape',
      link: '/desinfection'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Protection Préventive',
      description: 'Programmes de prévention personnalisés pour éviter l\'apparition de nuisibles avec des inspections régulières et conseils experts',
      image: 'https://readdy.ai/api/search-image?query=professional%20preventive%20pest%20control%20service%20with%20inspection%20tools%20and%20monitoring%20equipment%20in%20clean%20environment%20showing%20expertise%20in%20prevention%20strategies%20with%20simple%20white%20background&width=600&height=400&seq=service-004&orientation=landscape',
      link: null
    },
    {
      icon: 'ri-building-line',
      title: 'Solutions Professionnelles',
      description: 'Services adaptés aux entreprises, restaurants, hôtels et industries avec des protocoles conformes aux normes sanitaires',
      image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20pest%20control%20service%20for%20businesses%20with%20modern%20equipment%20and%20professional%20team%20in%20clean%20office%20environment%20with%20simple%20white%20background&width=600&height=400&seq=service-005&orientation=landscape',
      link: null
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Suivi & Garantie',
      description: 'Accompagnement continu avec garantie de résultats et interventions de suivi pour assurer une protection durable',
      image: 'https://readdy.ai/api/search-image?query=professional%20pest%20control%20follow-up%20service%20with%20customer%20support%20and%20quality%20guarantee%20showing%20expertise%20in%20long-term%20protection%20with%20simple%20white%20background&width=600&height=400&seq=service-006&orientation=landscape',
      link: null
    }
  ]
};

export function getServicesContent(): ServicesContent {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return JSON.parse(saved) as ServicesContent;
    }
  } catch {
    // ignore
  }
  return defaultServicesContent;
}

export function saveServicesContent(content: ServicesContent): boolean {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(content));
    return true;
  } catch {
    return false;
  }
}
